// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-tag[data-v-24b6ba5e] {\n  margin: 6px;\n}\n[data-v-24b6ba5e] .el-checkbox__label {\n  width: 125px;\n  height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
